import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../../CommonComponents/OPL/IconButton/IconButton';
import { Box } from '../../CommonComponents/OPL/Box/Box';

const CollapseButtonView = ({ isCollapsed, onCollapse, onExpand }) => (
  <Box position="absolute" right={isCollapsed ? 4 : 15} top={10}>
    <IconButton
      variant="secondary"
      size="small"
      icon={isCollapsed ? 'fas fa-caret-right' : 'fas fa-caret-left'}
      onClick={isCollapsed ? onExpand : onCollapse}
      aria-label="collapse"
      aria-expanded={!isCollapsed}
    />
  </Box>
);

CollapseButtonView.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onCollapse: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
};

export default CollapseButtonView;
